"use strict";
import BrokeredCarrierTermsStore from "../stores/brokered_carrier_terms_store";
var BrokeredCarrierTermsService = function() {
  var store = BrokeredCarrierTermsStore;
  this.all = () => {
    if (store.fetched) {
      return Promise.resolve(store.items);
    } else {
      return this.fetchAll();
    }
  };
  this.forClient = (tms_carrier) => this.all().then(
    (terms) => {
      if (tms_carrier.program_external_id) {
        return terms.filter(
          (term) => term.program_external_id === tms_carrier.program_external_id
        );
      } else {
        return terms;
      }
    }
  );
  this.fetchAll = () => {
    return Promise.resolve().then(() => {
      store.fetched = true;
      return $.get("/api/brokered_carrier_terms/").then(function(data) {
        store.addOrUpdateAll(data.brokered_carrier_terms);
        return store.items;
      });
    });
  };
};
var brokeredCarrierTermsService = new BrokeredCarrierTermsService();
export default brokeredCarrierTermsService;
